import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {TimeTrackingPaySchedule} from 'main/stores/time_tracking';

class ManageContainerState {
  store = new DomainStore();
  history;

  editingPaySchedule = {};
  editPayScheduleModalOpen = false;
  editingProject = {};
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  setPayScheduleInteractiveAgent(agent) {
    this.payScheduleInteractiveAgent = agent;
  }

  setPolicyInteractiveAgent(agent) {
    this.policyInteractiveAgent = agent;
  }

  setProjectInteractiveAgent(agent) {
    this.projectInteractiveAgent = agent;
  }

  async removePaySchedule(paySchedule) {
    await this.store.destroy(paySchedule);
  }

  async removeProject(project) {
    await this.store.destroy(project);
  }

  async createPolicy() {
    const {model} = await this.store.post(
      endpoints.TIME_TRACKING.POLICIES.ALL,
      types.TIME_TRACKING.POLICY
    );

    this.history.push(`/manage/policies/${model.id}/edit`);
  }

  async removePolicy(policy) {
    await this.store.destroy(policy);
    await this.policyInteractiveAgent.refresh();
    await this.payScheduleInteractiveAgent.refresh();
  }

  openEditPayScheduleModal(paySchedule) {
    this.errors = {};
    this.editingPaySchedule = new TimeTrackingPaySchedule(paySchedule);
    this.editPayScheduleModalOpen = true;
  }

  closeEditPayScheduleModal() {
    this.errors = {};
    this.editPayScheduleModalOpen = false;
  }

  async savePaySchedule() {
    const {model, errors} = await this.store.patch(this.editingPaySchedule);
    this.errors = errors;

    if (model) {
      await this.payScheduleInteractiveAgent.refresh();
      await this.policyInteractiveAgent.refresh();
      this.closeEditPayScheduleModal();
    }
  }

  async saveProject() {
    const {model, errors} = this.editingProject.isNew ?
      await this.store.post(endpoints.TIME_TRACKING.PROJECTS.DIRECTORY, types.TIME_TRACKING.PROJECT, this.editingProject) :
      await this.store.patch(this.editingProject);
    this.errors = errors;

    if (model) {
      await this.projectInteractiveAgent.refresh();
      this.closeEditProjectModal();
    }
  }

  async archiveProject() {
    const {model} = await this.store.post(
      this.editingProject.link('archive'),
      types.TIME_TRACKING.PROJECT
    );

    if (model) {
      this.projectInteractiveAgent.refresh();
      this.closeArchiveProjectModal();
    }
  }

  async unarchiveProject() {
    const {model} = await this.store.post(
      this.editingProject.link('unarchive'),
      types.TIME_TRACKING.PROJECT
    );

    if (model) {
      this.projectInteractiveAgent.refresh();
      this.closeUnarchiveProjectModal();
    }
  }

  customLinksForProject(project) {
    const links = [];
    if (project.hasLink('archive')) {
      links.push({
        order: 0,
        text: 'time_tracking.manage.projects.directory.Archive',
        action: project => this.openArchiveProjectModal(project)
      });
    }

    if (project.hasLink('unarchive')) {
      links.push({
        order: 0,
        text: 'time_tracking.manage.projects.directory.Unarchive',
        action: project => this.openUnarchiveProjectModal(project)
      });
    }

    return links;
  }

  paySchedulePath(paySchedule) {
    return `/manage/pay_schedules/${paySchedule.id}/`;
  }
}

export default ManageContainerState;
